import { useGetAppletsOfTheWeekQuery } from '@innovamat/glow-api-client';
import type { AppletsOfTheWeek } from '../modules/applets-of-the-week/applets-of-the-week';

type Props = {
  classroomId: string;
  enabled?: boolean;
  locale: string;
};

type UseGetAppletsOfTheWeek = {
  appletsOfTheWeek: AppletsOfTheWeek | undefined;
  isError: boolean;
  isFetching: boolean;
  isLoading: boolean;
  refetch: () => void;
};

function useGetAppletsOfTheWeek({
  classroomId,
  enabled = true,
  locale,
}: Props): UseGetAppletsOfTheWeek {
  const { data, isLoading, isFetching, isError, refetch } =
    useGetAppletsOfTheWeekQuery(
      {
        classroomId,
        locale,
      },
      {
        enabled,
      }
    );

  return {
    appletsOfTheWeek: data?.getAppletsOfTheWeek,
    isError,
    isFetching,
    isLoading,
    refetch,
  };
}

export { useGetAppletsOfTheWeek };
